export default __webpack_public_path__ + "static/media/4 icon (1).0839b73f.jpg";